<template>
  <div
    :class="`basic-article section ${article.theme} ${className ? className : ''} ${
      article.sectionType === 'wide-column' ? 'wide-column' : ''
    } ${article.sectionType === 'single-column' ? 'single-column' : ''}`"
    :id="sectionId || ''"
  >
    <div v-if="isTitleOnTop" class="section__heading">
      <h2 v-html="article.heading"></h2>
    </div>
    <div
      class="section__wrapper"
      :class="{
        'title-on-top': isTitleOnTop,
        'contains-action-link': containsActionLink,
        'image-on-left': isImagePositionLeft,
        'centered-content': isContentCentered,
      }"
    >
      <div class="basic-article__column">
        <h2 v-html="article.heading" v-if="!isTitleOnTop && article.heading"></h2>
        <div v-html="getLinkFormattedContent"></div>
        <template v-if="article.linkUrl">
          <div class="link-wrapper">
            <a
              v-if="article.linkType === 'external'"
              :href="article.linkUrl"
              :class="`form-button ${article.linkStyle === 'default' ? 'default' : 'primary'}`"
              target="_blank"
            >
              <span>{{ article.linkText }}</span>
            </a>
            <a
              v-else-if="article.linkType === 'other'"
              :href="article.linkUrl"
              :class="`form-button ${article.linkStyle === 'default' ? 'default' : 'primary'}`"
            >
              <span>{{ article.linkText }}</span>
            </a>
            <RouterLink
              v-if="article.linkUrl && article.linkType === 'internal'"
              :to="article.linkUrl"
              :class="`form-button ${article.linkStyle === 'default' ? 'default' : 'primary'}`"
            >
              <span>{{ article.linkText }}</span>
            </RouterLink>
          </div>
        </template>
        <template v-else-if="article.linkType === 'contact'">
          <form-button :text="article.linkText" @click.native="openAgencyForm()" theme="primary"></form-button>
        </template>
        <template v-if="article.secondaryLinkUrl">
          <RouterLink
            v-if="article.secondaryLinkType === 'internal'"
            class="action-link secondary-link"
            :to="article.secondaryLinkUrl"
          >
            {{ article.secondaryLinkText }}
          </RouterLink>
          <a
            v-else-if="article.secondaryLinkType === 'external'"
            :href="article.secondaryLinkUrl"
            target="_blank"
            class="action-link secondary-link"
          >
            {{ article.secondaryLinkText }}
          </a>
        </template>
        <template v-if="bottomLink?.route && bottomLink?.text">
          <div class="bottom-link">
            <a :href="bottomLink?.route" v-if="bottomLink?.type === 'link'" class="link-with-icon" tabindex="0">
              <span>{{ bottomLink.text }}</span>
              <i class="icon-chevron-right" aria-hidden="true"></i>
            </a>
            <form-button
              :text="bottomLink?.text"
              theme="primary"
              @click.native="openAgencyForm()"
              v-if="bottomLink?.type === 'button'"
            ></form-button>
          </div>
        </template>
      </div>

      <div class="basic-article__column" v-if="article.sectionType !== 'single-column' && article.imageUrl">
        <div
          v-if="article.imageUrl"
          :class="`basic-article__image ${article.imageType === 'contain' ? '' : 'background-image'}`"
          :style="`background-image: url(${article.imageUrl}?fm=webp)`"
        ></div>

        <div v-if="article.sectionType === 'tiles'">
          <promotion-boxes :box-data="article.tiles" box-style="vertical"></promotion-boxes>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ColumnAd from '../column-ad/column-ad.vue';
import { defineAsyncComponent, defineComponent } from 'vue';

export default defineComponent({
  components: {
    ColumnAd,
    PromotionBoxes: defineAsyncComponent(() => import('@/app/components/promotion-boxes/promotion-boxes.vue')),
    FormButton: defineAsyncComponent(() => import('@/app/components/form-button/form-button.vue')),
    Dialogue: defineAsyncComponent(() => import('@/app/components/dialogue/dialogue.vue')),
  },
  name: 'basic-article',
  props: {
    article: {
      type: Object,
      required: true,
    },
    bottomLink: {
      type: Object,
      required: false,
    },
    sectionId: {
      type: String,
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
    options: {
      type: Object,
      required: false,
    },
  },
  methods: {
    openAgencyForm() {
      this.$bus.$emit('openDialogue', 'contact-full');
    },
  },
  computed: {
    isTitleOnTop() {
      return this.options && this.options.hasOwnProperty('titleOnTop') && this.options.titleOnTop;
    },
    containsActionLink() {
      return this.options && this.options.hasOwnProperty('containsActionLink') && this.options.containsActionLink;
    },
    isImagePositionLeft() {
      return this.article.imagePosition && this.article.imagePosition === 'left';
    },
    isContentCentered() {
      return !this.article.imageUrl;
    },
    getLinkFormattedContent() {
      return this.article.text.replace(
        /(<a\s+[^>]*href="(?!\/)(?!https?:\/\/(?:[a-zA-Z0-9-]+\.)?op-koti\.fi)[^"]*"[^>]*>)(.*?)(<\/a>)/g,
        '$1$2<i class="icon-linkexternal" role="img" aria-label="Avautuu toiseen verkkopalveluun -ikoni"></i>$3'
      );
    },
  },
});
</script>
